import { Fragment } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Preloader from "../../components/Preloader/Preloader";
import { Outlet } from "react-router-dom";
import { useProfileStore } from "../../store/useUserStore";

const DefaultLayout = () => {
    const { loading } = useProfileStore()
    
    return (
        <Fragment>
            <Header />
            <Outlet/>
            {loading && <Preloader/>}
            <Footer/>
        </Fragment>
    );
};

export default DefaultLayout;
